function checkRoles(userRoles = [], permittedRoles = []) {
  return userRoles.some(ur => permittedRoles.includes(ur));
}

export { checkRoles };
